import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory} from "../../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {SwitchAnnualDialogComponent} from "../ds-billing-info/switch-annual-dialog/switch-annual-dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {getCurrencySymbol, isCurrencySymbol} from "../../../../shared/utils/currency-symbols";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'db-current-sub-plan',
    templateUrl: './current-sub-plan.component.html',
    styleUrl: './current-sub-plan.component.scss',
    standalone: false
})
export class CurrentSubPlanComponent implements OnInit, OnDestroy {
  @Input('userSubscription') set userSubs(subscription: UserSubscription) {
    if (!subscription) {
      return;
    }
    this.userSubscription = subscription;
  }
  @Input() annualSubscription: UserSubscription;
  @Input() annualPrice: number;
  fullyOpened = true;
  protected readonly UserSubscriptionStatus = UserSubscriptionStatus;
  protected readonly indexedDB = indexedDB;

  isMobile = window.innerWidth <= 991;
  userSubscription: UserSubscription;
  currentPlanOptions = [];
  currencySymbol: string = '$';
  isCurrencyBeforeAmount: boolean = true;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();


  protected readonly UserSubscriptionCategory = UserSubscriptionCategory;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
      let features = this.userSubscription && this.userSubscription.agencyFeatures || [];

      // Transform features based on slug and categorize them
      const builderFeatures = [];
      const ecommerceFeatures = [];
      const otherFeatures = [];

      features.forEach(feature => {
          switch (feature.slug) {
              case 'builder_type':
                  if (feature.value === 'both') {
                      builderFeatures.push({
                          ...feature,
                          title: 'text_aiClassicBuilder',
                          value: null
                      });
                      builderFeatures.push({
                          ...feature,
                          title: 'text_aiVibeBuilder',
                          value: null
                      });
                  } else if (feature.value === 'wvc' && this.userSubscription?.plan?.vibeService) {
                      builderFeatures.push({
                          ...feature,
                          title: 'text_aiVibeBuilder',
                          value: null
                      });
                  } else if (feature.value === 'section_based' && this.userSubscription?.plan?.aiBuilderService) {
                      builderFeatures.push({
                          ...feature,
                          title: 'text_aiClassicBuilder',
                          value: null
                      });
                  }
                  break;

              case 'allow_woocommerce_service':
                  ecommerceFeatures.push({
                      ...feature,
                      title: 'text_ecommerceFeatureTitle',
                      value: null
                  });
                  break;

              case 'monthly_generation_limit':
                  otherFeatures.push({
                      ...feature,
                      title: 'text_monthlyGeneration'
                  });
                  break;

              case 'monthly_credit_limit':
                  otherFeatures.push({
                      ...feature,
                      title: 'text_monthlyCredit'
                  });
                  break;

              case 'tenweb_hosting':
                  otherFeatures.push({
                      ...feature,
                      title: 'text_hostedProject'
                  });
                  break;

              default:
                  otherFeatures.push(feature);
                  break;
          }
      });

      // Combine in the desired order: builders first, then ecommerce, then others
      this.currentPlanOptions = [...builderFeatures, ...ecommerceFeatures, ...otherFeatures];

      if (this.userSubscription && this.userSubscription.trialClient) {
          const trialFeatures = [
              {
                  title: 'text_premiumCloudHosting',
                  value: null
              },
          ];
          this.currentPlanOptions = [...this.currentPlanOptions, ...trialFeatures];
      }

      this._getCompanyInfo();
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((companyInfo: any) => {
        this.currencySymbol = getCurrencySymbol(companyInfo?.agency?.currency);
        this.isCurrencyBeforeAmount = isCurrencySymbol(this.currencySymbol);
      });
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
